import { render } from "./policyDetail.vue?vue&type=template&id=1842ca4a&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"

import "./policyDetail.vue?vue&type=style&index=0&id=1842ca4a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1842ca4a"]])

export default __exports__